// src/utils/supabase.ts — build 2026-05-13
import { createClient } from '@supabase/supabase-js';

// Configuration Supabase
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// ✅ DEBUG: Log des variables d'environnement
console.log('🔍 DEBUG SUPABASE CONFIG:', {
  supabaseUrl: supabaseUrl,
  supabaseAnonKey: supabaseAnonKey ? `${supabaseAnonKey.substring(0, 20)}...` : 'MISSING',
  hasUrl: !!supabaseUrl,
  hasKey: !!supabaseAnonKey,
  urlLength: supabaseUrl.length,
  keyLength: supabaseAnonKey.length
});

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ SUPABASE CONFIG ERROR: Missing environment variables');
  throw new Error('Supabase environment variables are missing! Please check your .env file.');
}

// Client Supabase standard (avec RLS)
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true // <-- Changez cette ligne à 'true'
  },
  global: {
    headers: {
      'X-Client-Info': 'dpewizard-frontend'
    }
  }
});

// ✅ DEBUG: Confirmer création du client
console.log('✅ SUPABASE CLIENT CREATED:', {
  clientExists: !!supabase,
  supabaseUrl: supabase.supabaseUrl,
  supabaseKey: supabase.supabaseKey ? `${supabase.supabaseKey.substring(0, 20)}...` : 'MISSING'
});

// Vérifier la connexion
export const checkSupabaseConnection = async () => {
  try {
    console.log('🔍 DEBUG: Testing Supabase connection...');
    const { data, error } = await supabase.from('profiles').select('count', { count: 'exact' }).limit(1);
    if (error) {
      console.error('Supabase connection error:', error);
      return false;
    }
    console.log('✅ DEBUG: Supabase connection test successful');
    return true;
  } catch (err) {
    console.error('Supabase connection check failed:', err);
    return false;
  }
};

export default supabase;
